const initialState = {
    message: 'Welcome Back',
    level: 'info',
    icon: 'tick',
    id: '1',
};

export default initialState;
